// extracted by mini-css-extract-plugin
module.exports = {"boldText":"styles_boldText__1-hz8","frameWrapper":"styles_frameWrapper__1-QBh","errorsHazzardParent":"styles_errorsHazzardParent__6epZV"};